import React from 'react';
import { Stack, Button, Box, IconButton } from '@mui/material';
import { EditUnitDialog } from './edit-unit-dialog';
import PlaceIcon from '@mui/icons-material/Place';

import { UnitFragment } from '../../../generated/graphql';

import { TextBody1 } from '../../../components/text-body-1';
import { TextCaption } from '../../../components/text-caption';

interface FormFields {
  name: string;
  address: string;
  description: string;
  note: string;
}

interface UnitBasicInfoSectionProps {
  unit: UnitFragment;
  onEdit: (data: FormFields) => void;
  updateLoading: boolean;
  disabled?: boolean;
}

export function UnitBasicInfoSection(props: UnitBasicInfoSectionProps) {
  const { onEdit, updateLoading, disabled = false, unit } = props;
  const [dialogOpen, setDialogOpen] = React.useState(false);

  const handleEditSubmit = (data: FormFields) => {
    onEdit(data);
    setDialogOpen(false);
  };

  const openGoogleMaps = () => {
    if (unit.address) {
      const encodedAddress = encodeURIComponent(unit.address);
      window.open(`https://www.google.com/maps/search/${encodedAddress}`, '_blank');
    }
  };

  return (
    <Stack spacing={2}>
      <Box>
        <TextCaption>Názov</TextCaption>
        <TextBody1 disabled={!unit.name}>{unit.name || 'Bez názvu'}</TextBody1>
      </Box>

      <Box>
        <TextCaption>Adresa</TextCaption>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <TextBody1 disabled={!unit.address}>{unit.address || 'Bez adresy'}</TextBody1>
          {unit.address && (
            <IconButton size="small" aria-label="open map" onClick={openGoogleMaps} sx={{ minWidth: 'auto', px: 1 }}>
              <PlaceIcon fontSize="small" />
            </IconButton>
          )}
        </Box>
      </Box>
      <Box>
        <TextCaption>Poznámka</TextCaption>
        <TextBody1 disabled={!unit.note}>{unit.note || 'Bez poznámky'}</TextBody1>
      </Box>
      <Box>
        <TextCaption>Opis</TextCaption>
        <TextBody1 disabled={!unit.description}>{unit.description || 'Bez opisu'}</TextBody1>
      </Box>

      <Button
        variant="outlined"
        onClick={() => setDialogOpen(true)}
        disabled={disabled || updateLoading}
        sx={{ alignSelf: 'flex-start' }}
      >
        Upraviť
      </Button>

      <EditUnitDialog
        open={dialogOpen}
        unit={unit}
        loading={updateLoading}
        onClose={() => setDialogOpen(false)}
        onSubmit={handleEditSubmit}
      />
    </Stack>
  );
}
